export const ROUTE_LOGIN = '/login';

// 상품(디자인)
export const ROUTE_PRODUCTS_PIECES = '/products/pieces';
export const ROUTE_PRODUCTS_SET = '/products/set';
export const ROUTE_PRODUCTS_CLASSIFICATION = '/products/classification';

// 액세서리
export const ROUTE_ACCESSORIES_PARTS = '/accessory/parts';
export const ROUTE_ACCESSORIES_CONSUMABLES = '/accessory/consumables';
export const ROUTE_ACCESSORIES_NONSALES ='/accessory/non-sales'

// DIY
export const ROUTE_DIY_PALETTE = '/diy/palette';
export const ROUTE_DIY_PATTERN = '/diy/pattern';
export const ROUTE_DIY_STICKER = '/diy/sticker';

// 고객
export const ROUTE_CUSTOMER = '/customer';

// 주문
export const ROUTE_ORDER = '/order';

// 결제
export const ROUTE_PAYMENT = '/payment';

// 매장
export const ROUTE_STORE = '/store';

// 장비
export const ROUTE_EQUIPMENT_VENDING_MACHINE = '/equipment/vending-machine';

// 기획전
export const ROUTE_SPECIAL_EXHIBITION = '/special-exhibition';
